import React from "react";

import { string } from "prop-types";

const TableCellRenderer = ({ firstItem = "", firstItemClass = "" }) => {
  return (
    <div className="table-cell-renderer">
      <span
        className={`capitalize table__value table-cell-renderer__first ${
          firstItem ? `table-cell-renderer__first--${firstItemClass}` : ""
        }`}
      >
        {firstItem}
      </span>
    </div>
  );
};

TableCellRenderer.propTypes = {
  firstItem: string,
  firstItemClass: string,
};

export default TableCellRenderer;
